import { setupDayjsExtensions } from '@/utils/setupDayjsExtensions';
import { EnvironmentService, SentryService } from '@propify-tenant-client/services';
import { Big } from 'big.js';
import ReactGA from 'react-ga4';

EnvironmentService.init();
SentryService.init();

Big.RM = 2;
Big.DP = 10;

if (process.env.NODE_ENV === 'production') {
  // cspell:disable-next-line
  ReactGA.initialize('G-XTWPR873NR');
}

setupDayjsExtensions();
